import { render, staticRenderFns } from "./addcount.vue?vue&type=template&id=b37960e0&scoped=true"
import script from "./addcount.vue?vue&type=script&lang=js"
export * from "./addcount.vue?vue&type=script&lang=js"
import style0 from "./addcount.vue?vue&type=style&index=0&id=b37960e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37960e0",
  null
  
)

export default component.exports